import { render, staticRenderFns } from "./StoreShops.vue?vue&type=template&id=5c3f22e9&"
import script from "./StoreShops.vue?vue&type=script&lang=js&"
export * from "./StoreShops.vue?vue&type=script&lang=js&"
import style0 from "./StoreShops.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports